export default __webpack_public_path__ + "static/pro@mob-08ecda55bbc469e7bedc38f128815eeb.webp";